import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        {/* Animated 404 */}
        <div className="not-found-animation">
          <span className="not-found-4">4</span>
          <span className="not-found-0">
            <span className="gear-icon">⚙️</span>
          </span>
          <span className="not-found-4">4</span>
        </div>

        <h1 className="not-found-title">Page Not Found</h1>
        <p className="not-found-description">
          Oops! The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>

        <div className="not-found-actions">
          <Link to="/" className="btn btn-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            Back to Home
          </Link>
          <Link to="/products" className="btn btn-secondary">
            View Products
          </Link>
          <Link to="/contact" className="btn btn-ghost">
            Contact Us
          </Link>
        </div>

        {/* Quick Links */}
        <div className="not-found-links">
          <p>Or try these popular pages:</p>
          <div className="quick-links">
            <Link to="/about">About Us</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/blog">Blog</Link>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="not-found-bg">
        <div className="not-found-orb not-found-orb-1"></div>
        <div className="not-found-orb not-found-orb-2"></div>
      </div>
    </div>
  );
};

export default NotFound;

